import {ISpecification} from "@/models/specifications/SpecificationHelpers/ISpecification";
import {IShipmentStore} from "@/models/StoreModels";

export class StoreShipmentHubIdIsCorrect implements ISpecification<IShipmentStore> {
  public IsSatisfiedBy(candidate: IShipmentStore): boolean {
    return candidate.from_hub_id > 0;
  }
}
